// extracted by mini-css-extract-plugin
export default {"RefPillOcticon":"RefPill-module__RefPillOcticon--QLQIP","RefPillTruncate":"RefPill-module__RefPillTruncate--Nm3ph","RefPillText":"RefPill-module__RefPillText--pUrWr"};